import { Component, NgModule, Input, ChangeDetectionStrategy } from '@angular/core';
import { AppTranslationService } from '../services/app-translation.service';
@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PageHeaderComponent
{
    constructor(private translationService : AppTranslationService) {
        this.translateTitle = false;
    }

    @Input()
    title: string | undefined;

    @Input()
    icon: string  | undefined;

    @Input()
    translateTitle: boolean;

    getTitle() : string {
        if (this.translateTitle) {
            return this.translationService.getTranslation(this.title);
        } else {
            return this.title;
        }
    }

}
